/* globals ALKMaps */
const config = require("config");

(function () {

  angular
    .module("app")
    .factory("routeService", routeService);

  routeService.$inject = ["$rootScope", "$window", "$sce", "$q", "_", "mapService", "alkModalService", "$filter", "optionsUI", "RouteItem",
    "LocationItem", "alkGeocodeService", "$http", "UserProvider", "$location", "conversionService", "routingProfile", "$timeout",
    "stopService", "$document", "eventTracker","alkAuthenticationService", "applicationSettingsService"
  ];

  function routeService($rootScope, $window, $sce, $q, _, mapService, alkModalService, $filter, optionsUI, RouteItem,
    LocationItem, alkGeocodeService, $http, userProvider, $location, conversionService, routingProfile, $timeout,
    stopService, $document, eventTracker,alkAuthenticationService, applicationSettingsService) {
    //Locals

    var mapId = "pcmMap";
    var routes = [];
    var reportWindows = [];
    var selectedRoute = null;
    var isIE = false;
    var nextRouteNumber = 1;
    var routeColors = ["#123EC4", "#B84A00", "#7318A1", "#1E6CA8", "#B50E59", "#450DBD", "#009DC4", "#E63D00"];
    var uiColors = ["#889EE1", "#DBA47F", "#B98BD0", "#8EB5D3", "#DA86AC", "#A286DE", "#7FCEE1", "#F29E7F"];
    var availableRoutColors = angular.copy(routeColors);
    var availableUiColors = angular.copy(uiColors);

    if ($window.navigator.userAgent.match(/Trident/) || $window.navigator.userAgent.match(/Edge/)) {
      isIE = true;
    }

    var service = {
      isRouteUnique: isRouteUnique,
      selectRoute: selectRoute,
      getSelectedRoute: getSelectedRoute,
      getRoute: getRoute,
      getAllRoutes: getAllRoutes,
      hasRoutes: hasRoutes,
      newRoute: newRoute,
      addStop: addStop,
      deleteRoute: deleteRoute,
      deleteAllRoutes: deleteAllRoutes,
      updateAllRoutesOptions: updateAllRoutesOptions,
      updateAllRoutesAppSettingsOptions:updateAllRoutesAppSettingsOptions,
      getReportWindow: getReportWindow,
      newReportWindow: newReportWindow,
      closeAllReports: closeAllReports,
      loadSessionRoutes: loadSessionRoutes,
      clearSessionRoutes: clearSessionRoutes,
      runRoute: runRoute,
      runAllRoutes: runAllRoutes,
      reloadRoutes: reloadRoutes,
      deleteStop: deleteStop,
      getOptionsUI: getOptionsUI,
      optimizeStopOrderPromise: optimizeStopOrderPromise,
      saveSessionRoute: saveSessionRoute,
      routeModified: routeModified,
      routeModifiedError: routeModifiedError,
      dragStart: dragStart,
      setDraggable: setDraggable,
      checkUnsavedRoutes:checkUnsavedRoutes,
      getDataset:getDataset,
      checkHistoricalVersion:checkHistoricalVersion
    };

    return service;

    /////////////////////

    function incrementAPIRouteCount() {
      if (userProvider.getUser().accountType === "Trial" && userProvider.getUser().remainingRoutes <= 0) {
        $location.url("/account");
        return $q.reject();
      } else {
        var deferred = $q.defer();

        $http.post("/api/UserInfo/IncrementAPIRouteCount").success(response => {
          const remainingRoutes = response.RemainingRoutes;
          userProvider.getUser().remainingRoutes = remainingRoutes;
          deferred.resolve();
          eventTracker.setAttr("Routes Remaining (Trial User)", remainingRoutes);
        }).error(deferred.reject);

        return deferred.promise;
      }
    }

    function newRoute(name, stops, options, savedId, uiArrDepSelection, isDuplicatedRoute) {
      // the route is not already open, add it.
      if (routes.length < 8) {
        var defaultOptions = angular.copy(routingProfile.getDefaultOptions());

        //Set highway only for Standard accounts
        if (!(userProvider.getUser().subscriptionLevel === "Premium" || userProvider.getUser().subscriptionLevel === "Trial")) {
          if (defaultOptions !== undefined) {
            defaultOptions.highwayOnly = true;
          }
        }

        var tempRoute = new RouteItem(name, stops, defaultOptions);
        tempRoute.name = angular.isDefined(name) ? name : ("Route " + nextRouteNumber++);
        var rc = availableRoutColors.splice(0, 1);
        var uc = availableUiColors.splice(0, 1);
        tempRoute.color = rc[0];
        tempRoute.uicolor = uc[0];

        // if we are opening a saved route, count this route
        if (angular.isDefined(savedId)) {
          tempRoute.hasBeenCounted = true;
          incrementAPIRouteCount();
        } else if (isDuplicatedRoute === true) {
          tempRoute.hasBeenCounted = true;
          incrementAPIRouteCount();
        } else {
          tempRoute.hasBeenCounted = false;
        }

        if (options) {
          angular.extend(tempRoute.options, options);
        }

        if (savedId !== undefined) {
          tempRoute.savedId = savedId;
        }

        if (uiArrDepSelection) {
          angular.extend(tempRoute.uiArrDepSelection, uiArrDepSelection);
        }

        tempRoute.options.name = tempRoute.name;

        // todo: this should check temp route, this will run the route even if the number of stops is 1, should this be if tempRoute.stops.length >= 2?
        if (stops) {
          tempRoute.updateStopIcons();
          runRoute(tempRoute, true);
        }

        routes.push(tempRoute);
        var userCfg = applicationSettingsService.getUserCfg(); // get user cfg
        const least = getLeastVersion(routes);
        if(userCfg && userCfg.Minimum_Data_Version_Used && userCfg.Minimum_Data_Version_Used !== "") {
          const leastVersionIndex = getLeastVersionIndex(least.options.dataVersion, userCfg.Minimum_Data_Version_Used);
          if (leastVersionIndex === 0) {
            userCfg.Minimum_Data_Version_Used = least.options.dataVersion;
            applicationSettingsService.updateUserCfg(userCfg);
            window.sessionStorage.setItem("Minimum_Data_Version_Used", least.options.dataVersion);
            eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
              version: least.options.dataVersion
            });
          }          
        }
        selectRoute(tempRoute);
        return tempRoute;
      }
    }

    function getLeastVersion(versions) {
      const filterEmptyDataVersionRoutes = versions.filter(route => route.options.dataVersion && route.options.dataVersion !== "");
      const least = filterEmptyDataVersionRoutes.reduce((previous, current) => {
        const leastVersionIndex = getLeastVersionIndex(current.options.dataVersion, previous.options.dataVersion);
        if(leastVersionIndex >= 0)  {
          return leastVersionIndex === 0 ? current : previous
        } else {
          return  angular.lowercase(current.options.dataVersion) < angular.lowercase(previous.options.dataVersion) ? current : previous;
        }
      });
      return least;
    }

    function getLeastVersionIndex(version, version1) {
      const currentVersionNo = version.length > 5 ? angular.lowercase(version) : parseInt(version.substring(3,5));
      const previousVersionNo = version1.length > 5 ? angular.lowercase(version1) : parseInt(version1.substring(3,5));
      if((typeof (currentVersionNo) === "number") && (typeof (previousVersionNo) === "number")) {
        return currentVersionNo > previousVersionNo ? 1 : 0;
      } else {
        const versionArray =  [currentVersionNo, previousVersionNo];
        const index = versionArray.findIndex(val => typeof (val) === "number" );
        return index;
      }
    }

    function selectRoute(r) {
      if (r.isSelectedRoute && r.isOpen) {
        r.isOpen = false;
      } else {
        for (var i = 0; i < routes.length; i++) {
          routes[i].isSelectedRoute = false;
          routes[i].isOpen = false;
        }
        r.isSelectedRoute = true;
        r.isOpen = !r.isOpen;
        selectedRoute = r;
        mapService.activateRoute(r.id, mapId);
        $timeout(function() {
          $rootScope.$broadcast("FocusSearchField");
        }, 100);
      }
    }

    function getSelectedRoute() {
      return selectedRoute;
    }

    function getRoute(routeId) {
      return _.find(routes, {
        id: routeId
      });
    }

    function getReportWindow(routeId) {
      var winObj = _.find(reportWindows, {
        id: routeId
      });
      if (typeof (winObj) !== "undefined") {
        return winObj.window;
      } else {
        return null;
      }
    }

    function getAllRoutes() {
      return routes;
    }

    function hasRoutes() {
      return (routes.length > 0);
    }

    function deleteRoute(routeId) {
      var idx = _.findIndex(routes, {
        id: routeId
      });

      if (routes[idx].reportWindow) {
        routes[idx].reportWindow.close();
      }

      var removedRoutes = _.remove(routes, {
        id: routeId
      });
      availableRoutColors.push(removedRoutes[0].color);
      availableUiColors.push(removedRoutes[0].uicolor);
      selectedRoute = null;
      $window.sessionStorage.removeItem("route_" + routeId);
      closeReportWindow(routeId);

      return idx;
    }

    function deleteAllRoutes() {
      clearSessionRoutes();
      closeAllReports();
      availableRoutColors = [];
      availableUiColors = [];
      for (var i = 0; i < routeColors.length; i++) {
        availableRoutColors.push(routeColors[i]);
      }
      for (var j = 0; j < uiColors.length; j++) {
        availableUiColors.push(uiColors[j]);
      }
      routes = [];
      reportWindows = [];
      selectedRoute = null;
    }

    function updateAllRoutesOptions(updatedOptions) {
      if (updatedOptions != null) {
        _.each(routes, function (route) {
          var temp = route.options.estimatedTimeOpts;
          route.options = updatedOptions;
          route.options.estimatedTimeOpts = temp;
        });
      }
    }

    function updateAllRoutesAppSettingsOptions(updatedOptions) {
      if (updatedOptions !== null) {
        for (var i = 0; i < routes.length; i++)
        {
          routes[i].options.costGHG = updatedOptions.costGHG;
          routes[i].options.costMaintEmpty = updatedOptions.costMaintEmpty;
          routes[i].options.costMaintLoad = updatedOptions.costMaintLoad;
          routes[i].options.costPerFuelUnit = updatedOptions.costPerFuelUnit;
          routes[i].options.costTimeEmpty = updatedOptions.costTimeEmpty;
          routes[i].options.costTimeLoad = updatedOptions.costTimeLoad;
          routes[i].options.fuelEconEmpty = updatedOptions.fuelEconEmpty;
          routes[i].options.fuelEconLoad = updatedOptions.fuelEconLoad;
          routes[i].options.exchangeRate = updatedOptions.exchangeRate;
          routes[i].options.fuelUnits = updatedOptions.fuelUnits;
          routes[i].options.distanceUnits = updatedOptions.distanceUnits;
          routes[i].options.inclTollData = updatedOptions.inclTollData;
          routes[i].options.tollPlan = updatedOptions.tollPlan;
          routes[i].options.tollCurrency = updatedOptions.tollCurrency;
          if (routes[i].options.trkUnits !== updatedOptions.trkUnits
          ) {
            routes[i].options.trkUnits = updatedOptions.trkUnits;
            routes[i].options = applicationSettingsService.changeUnits(routes[i].options);
          }
          if (routes[i].options.trkUnits === 0) {
            if (Array.isArray(routes[i].options.trkLength)) {
              routes[i].options.trkLength = conversionService.feetInchesToString(routes[i].options.trkLength);
              routes[i].options.trkHeight = conversionService.feetInchesToString(routes[i].options.trkHeight);
            }
            if (userProvider.getUser().region === "EU" && Array.isArray(routes[i].options.EUOptions.trlMaxHt)) {
              routes[i].options.EUOptions.trlMaxHt = conversionService.feetInchesToString(routes[i].options.EUOptions.trlMaxHt);
            }
          }
        }
      }
    }

    function newReportWindow(route) {
      var newWindow = window.open("/reports.html?id=" + route.id, "route_window_" + route.id, "height=700,width=1000");
      if (typeof newWindow !== "undefined") {
        newWindow.route = route;
        var thisWin = getReportWindow(route.id);
        if (thisWin) {
          thisWin = newWindow;
        } else {
          reportWindows.push({
            id: route.id,
            window: newWindow
          });
        }
      } else {
        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Report Window Blocked",
          bodyText: "Your pop-up blocker is preventing the reports from opening. Please allow pop-ups for this site.",
          okOnly: true
        });
      }
    }

    function updateReportWindow(route) {
      $rootScope.$broadcast("UpdateReport", route.id);
    }

    function closeAllReports() {
      for (var i = 0; i < routes.length; i++) {
        closeReportWindow(routes[i].id);
      }
      reportWindows = [];
    }

    function closeReportWindow(routeId) {
      var thisWin = getReportWindow(routeId);
      if (thisWin) {
        thisWin.close();
      }

      _.remove(reportWindows, {
        id: routeId
      });
    }

    function addStop(stop, route) {
      if ((route === undefined || route === null) && selectedRoute === null) {
        route = newRoute();
      } else if (route === undefined) {
        route = selectedRoute;
      }

      // if this route has not been counted toward the api key usage and the first time it calculates a route (which happens when the route gets its second stop), it should use one of it's remaining routes.
      // add the stop to the route after checking this, don't want to calculate a new route if this puts us over the limit
      if (route.hasBeenCounted === false && (route.stops.length + 1) === 2) {
        route.hasBeenCounted = true;
        incrementAPIRouteCount();
      }

      route.addStop(stop);
      mapService.resetFeatureEventControl();
    }

    function deleteStop(stop, route) {
      
      if (route === undefined && selectedRoute === null) {
        route = newRoute();
      } else if (route === undefined) {
        route = selectedRoute;
      }

      route.deleteStop(stop);

      // if the user removes every stop from a route reset this flag
      // todo: consider doing this reset when the number of stops hits 1?
      if (route.stops.length === 0) {
        route.hasBeenCounted = false;
      }
    }

    function saveSessionRoute(route) {
      var sessRoute = {
        savedId: route.savedId,
        name: route.name,
        stops: _.map(route.stops, "ALKObj"),
        options: route.options,
        uiArrDepSelection: route.uiArrDepSelection
      };
      $window.sessionStorage["route_" + route.id] = JSON.stringify(sessRoute);
    }

    function loadSessionRoutes() {
      var createLocItem = function (val) {
        if (!val.PlaceName) {
          return new LocationItem(val);
        } else {
          return new LocationItem(val, val.PlaceName);
        }
      };
      var sessRoutes = [];
      for (var i = 0; i < $window.sessionStorage.length; i++) {
        if ($window.sessionStorage.key(i).indexOf("route_") !== -1) {
          var r = {};
          r.sessRoute = JSON.parse($window.sessionStorage.getItem($window.sessionStorage.key(i)));
          r.tempStops = _.map(r.sessRoute.stops, createLocItem);
          sessRoutes.push(r);
        }
      }

      clearSessionRoutes();

      if (sessRoutes.length === 0) {
        newRoute();
      } else {
        for (var index = 0; index < sessRoutes.length; index++) {
          newRoute(sessRoutes[index].sessRoute.name, sessRoutes[index].tempStops, sessRoutes[index].sessRoute.options,
            sessRoutes[index].sessRoute.savedId, sessRoutes[index].sessRoute.uiArrDepSelection);
        }
      }
    }

    function clearSessionRoutes() {
      for (var i = $window.sessionStorage.length - 1; i >= 0; i--) {
        if ($window.sessionStorage.key(i).indexOf("route_") !== -1) {
          $window.sessionStorage.removeItem($window.sessionStorage.key(i));
        }
      }
    }

    function runRoute(route, frameRoute) {
      if (route === undefined) {
        route = getSelectedRoute();
      }
      if (route.isValidRoute()) {
        route.isCalculating = true;
        $timeout(function() {
          if ($document[0].activeElement) { // for IE 11 issue where activeElement is undefined
            $document[0].activeElement.blur();
          }
        });

        //remove cost options if not current version
        // keep the options on the route the same, only modify the copy of the route options.
        var tempOptions = angular.copy(route.options);
        if (route.options.dataVersion !== "current" && route.options.dataVersion !== "PCM_EU") {
          delete tempOptions.costPerFuelUnit;
          delete tempOptions.costGHG;
          delete tempOptions.fuelEconLoad;
          delete tempOptions.fuelEconEmpty;
          delete tempOptions.costMaintLoad;
          delete tempOptions.costMaintEmpty;
          delete tempOptions.costTimeLoad;
          delete tempOptions.costTimeEmpty;
        }

        // remove truckCfg if the vehicle type is auto
        if (route.options.vehicleType === 2) {
          delete tempOptions.trkAxles;
          delete tempOptions.trkHeight;
          delete tempOptions.trkLCV;
          delete tempOptions.trkLength;
          delete tempOptions.trkWeight;
          delete tempOptions.trkWidth;
          delete tempOptions.trkUnits;
        }

        var routePromise = mapService.addRoutePromise(route.id, route.color, route.stops, tempOptions, frameRoute, mapId);
        var reportPromise = mapService.addReportPromise(route.id, route.stops, tempOptions, route.uiArrDepSelection, "Mileage, Directions");

        $q.all([routePromise, reportPromise]).then(function (response) {
          route.isError = false;
          route.errorMessage = "";
          var data = {
            report: response[1],
            routeId: response[0].routeId,
            stops: response[0].stops
          };
          runRouteIsDone(route, data);
        }).catch(function (response) {
          route.isCalculating = false;
          $rootScope.$broadcast("FocusSearchField");
          route.isError = true;
          route.errorMessage = response;
        });
        return routePromise;
      }
    }

    function routeModified(response) {
      var re = getRoute(response.routeId);
      var stopsNeedReverGeocode = [];

      //Duplicate (modifiable) stop list need to handle identical favorites [PCMW-137].
      var tempStops = angular.copy(re.stops);

      for (var sIndex = 0; sIndex < response.stops.length; sIndex++) {
        var stop = response.stops[sIndex];
        var foundLocationItem = false;
        for (var lIndex = 0; lIndex < tempStops.length; lIndex++) {
          var stopData = tempStops[lIndex].Coords;
          var ll = mapService.transformToSphericalMercator(new ALKMaps.LonLat(stopData.Lon, stopData.Lat), mapId);
          if (mapService.distanceTo(ll.lon, ll.lat, stop.x, stop.y) <= 0.25) {
            response.stops[sIndex] = re.stops[lIndex];
            foundLocationItem = true;
            //Set lat/lon to unused values to keep identical (favorite) stops from being matched again [PCMW-137].
            tempStops[lIndex].Coords.Lat = NaN;
            tempStops[lIndex].Coords.Lon = NaN;
            break;
          }
        }
        if (foundLocationItem === false) {
          var aStop = mapService.transformFromSphericalMercator(new ALKMaps.LonLat(stop.x, stop.y), mapId); //new ALKMaps.LonLat(stop.x, stop.y).transform(map.getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));
          aStop.ll = new ALKMaps.LonLat(stop.x, stop.y);
          stopsNeedReverGeocode.push({
            stop: aStop,
            index: sIndex
          });
        }
      }

      var promises = stopsNeedReverGeocode.map(function (list) {
        var deferred = $q.defer();

        alkGeocodeService.reverseGeocode(list.stop, {
            region: userProvider.getUser().region,
            dataset: userProvider.getUser().dataset
          })
          .then(function (resp) {
            resp[0].origLatlon = `${resp[0].Coords.Lat}, ${resp[0].Coords.Lon}`;
            var tempLocItem = new LocationItem(resp[0]);
            tempLocItem.smLonLat = list.stop.ll;
            deferred.resolve({
              stop: tempLocItem,
              index: list.index
            });
          });

        return deferred.promise;
      });

      var qAll = $q.all(promises);
      qAll.then(function (results) {
        for (var qIndex = 0; qIndex < results.length; qIndex++) {
          response.stops[results[qIndex].index] = results[qIndex].stop;
        }

        //Copy any saved data such as stop duration or it will be overwritten
        if(re.stops.length === response.stops.length) {
          _.each(response.stops, function(stop, index) {
            stop.copySavedData(re.stops[index]);
          });
        }

        re.stops = response.stops;

        runRoute(re);
        //runRouteIsDone(re, response);
      });
    }

    function routeModifiedError(response) {
      var route = getSelectedRoute();

      route.isError = true;
      route.errorMessage = "Can't drag stop to that location";

      //Re-run old route to reset
      runRoute(route);
    }

    function runRouteIsDone(route, response) {
      route.stops = response.stops;
      route.updateStopIcons();
      route.syncStopsToSortableItems(route.getSearchPanelIndex());
      $timeout(function () {
        route.isCalculating = false;
        $rootScope.$broadcast("FocusSearchField");
      }, 500);

      if (route.uiArrDepSelection.type !== "None") {
        route.hasTime = true;
      }

      for (var i = 0; i < route.stops.length; i++) {
        route.stops[i].Miles = response.report[0].ReportLines[i].LMiles;
        route.stops[i].Cost = response.report[0].ReportLines[i].LCostMile;
        route.stops[i].Hours = response.report[0].ReportLines[i].LHours;
        route.stops[i].Tolls = response.report[0].ReportLines[i].LTolls;

        var arrOrDep = "";
        if (route.uiArrDepSelection.type !== "None") {
          if(i === 0) {
            arrOrDep = "Dep";
          } else {
            arrOrDep = "Arr";
          }
          arrOrDep += " ";
        }

        var etaDateTime = response.report[0].ReportLines[i].EtaEtd;
        var momentEta = moment(etaDateTime, "M/D/YYYY h:mm A", true);
        route.stops[i].displayETA = "";

        if (momentEta.isValid()) {
          var etaDate = momentEta.format("M/D");
          var etaTime = momentEta.format("h:mm A");
          route.stops[i].displayETA = etaDate + "<br/>" + etaTime;
        } else {
          momentEta = moment(etaDateTime, "ddd H:mm A", true);
          if (momentEta.isValid()) {
            route.stops[i].displayETA = momentEta.format("ddd h:mm A");
          }
        }

        if (route.stops[i].displayETA !== "") {
          route.stops[i].displayETA = arrOrDep + route.stops[i].displayETA;
        }

        var fontColor = $filter("colorFilter")(route.color, "lighten", 0.25);
        var fillColor = "#FFFFFF";
        var strokeColor = $filter("colorFilter")(route.color, "lighten", 0.2);
        var strokeWidth = 3;
        var pointRadius = 9;

        if (i === 0) {
          fontColor = "#259800";
          strokeColor = "#279E00";

          if (route.options.hubRouting){
            route.stops[i].IconText = "H"
          }
          else{
          strokeWidth = 5.5;
          pointRadius = 6.5;
          }
        } else if (i === route.stops.length - 1 && !route.options.hubRouting) {
          fontColor = "#e25656";
          strokeColor = "#be2525";
          strokeWidth = 5.5;
          pointRadius = 6.5;
        }

        mapService.setRouteHandle(route.id, mapId, i, {
          externalGraphic: "",
          fontColor: fontColor,
          fontSize: "11",
          fontWeight: "700",
          strokeColor: strokeColor,
          pointRadius: pointRadius,
          strokeWidth: strokeWidth,
          fillColor: fillColor,
          label: route.stops[i].IconText,
          labelYOffset: (isIE) ? -4 : 0
        });
      }

      var l = response.report[0].ReportLines.length - 1;
      route.routeDistance = response.report[0].ReportLines[l].TMiles + " mi.";
      route.routeTMiles = response.report[0].ReportLines[l].TMiles;
      var timeArr = response.report[0].ReportLines[l].THours.split(":");
      var timeStr = "";
      if (parseInt(timeArr[0]) === 0) {
        timeStr = timeArr[1] + " min.";
      } else {
        timeStr = timeArr[0] + " hr. " + timeArr[1] + " min.";
      }
      route.routeTime = timeStr;
      route.routeTHours = response.report[0].ReportLines[l].THours;
      route.routeTTolls = response.report[0].ReportLines[l].TTolls;
      route.routeTCost = response.report[0].ReportLines[l].TCostMile;

      //save to sessionStorage
      saveSessionRoute(route);
      updateReportWindow(route);
    }

    function runAllRoutes() {
      _.each(routes, function (route) {
        runRoute(route, false);
      });

      mapService.restoreCenterZoom(mapId);
    }

    function getOptionsUI() {
      return optionsUI;
    }

    function reloadRoutes() {
      if (routes.length === 0) { //if there are no routes check the sessionStorage
        loadSessionRoutes();
      } else {
        runAllRoutes();
      }
    }

    function isRouteUnique(routeName) {
      var lowerCaseViewValue = angular.lowercase(routeName);

      var deferred = $q.defer();

      $http.get(config.daUrl + "trips/-1").success(function (trips) {
        var foundTrip = _.find(trips, function (trip) {
          return angular.lowercase(trip.Name) === lowerCaseViewValue;
        });

        if (foundTrip == null) {
          deferred.resolve();
        } else {
          deferred.reject();
        }
      }).error(function () {
        deferred.reject();
      });

      return deferred.promise;
    }

    /**
     * Function: optimizeStopOrderPromise
     *
     * Parameters:
     * opt - {Number} 0, 1 or 2
     */
    function optimizeStopOrderPromise(opt, route) {
      /*
      var stopsArr = [];
      for(var i = 0; i < route.stops.length; i++) {
        var stop = route.stops[i];
        var wsStop = {
          Location: {
            Coords: stop.Coords,
          },
          OptimizationOptions: {
            TimeWindow: {
              StartTime: stop.earliestArrivalTime.getWsFormattedTime(),
              EndTime: stop.latestArrivalTime.getWsFormattedTime()
            },
            WaitTime: stop.getDurationInSeconds(),
            //If "Keep Destination" option chosen and last stop: make it static. Also, first stop is always static
            IsStatic: (i === 0) || (opt === 2 && i === route.stops.length - 1)
          }
        };
        stopsArr.push(wsStop);
      }

      var req = {
        method: "POST",
        url: config.pcmwsUrl + "route/optimize?region=NA&dataset=PCM_NA",
        headers: {
          Authorization: "68B06901AF7DA34884CE5FB7A202A743"//config.alkmapsApiKey
        },
        data: {
          Route: {
            Name: route.name,
            Stops: stopsArr
          }
        }
      };

      return $http(req).then(function(results) {
        route.optimizeStops(results.data);
        return runRoute(route, true);
      }, function(error) {
        console.log(error);
        //return runRoute(route, true);
      });
      */

      return runRoute(route, true);
    }

    function dragStart(feature) {
      var routeId = feature.attributes.routeId;
      var route = getRoute(routeId);
      if (route != null) {
        return mapService.dragStart(feature, route.stops, mapId);
      }
    }

    function setDraggable(d) {
      mapService.setDraggable(d);
    }

    $rootScope.$on("UserLoggedIn", function (event, message) { // jshint ignore:line
      nextRouteNumber = 1;
    });

    function checkUnsavedRoutes() {
      var sessionRoutes = [];
      for (var i = $window.sessionStorage.length - 1; i >= 0; i--) {
        if ($window.sessionStorage.key(i).indexOf("route_") !== -1) {
          sessionRoutes.push(JSON.parse($window.sessionStorage.getItem($window.sessionStorage.key(i))));
        }}
      var unsavedroutes = sessionRoutes.find(route => route.savedId === undefined);
      if (!unsavedroutes) {
        return true;
      } else {
        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Unsaved Routes",
          bodyText: "You have unsaved changes that will be lost if you continue.",
          closeButtonText: "Cancel",
          actionButtonText: "Continue"

        }).then(() => {
          mapService.clearSavedCenterZoom();
          deleteAllRoutes();
          eventTracker.track(eventTracker.EVENTS.LOGOUT);
          alkAuthenticationService.logout().then(() => {
            $window.location.href = "";
          });

        });

        return false;
      }

    }
    function checkHistoricalVersion(version){
      return mapService.checkHistoricalVersion(version);
   
     }

     function getDataset () {
      var dataset = userProvider.getUser().dataset;
      var selRoute = this.getSelectedRoute();
      if (selRoute !== null &&
        selRoute.options !== null &&
        selRoute.options.dataVersion !== null) {
        var dataVersion = selRoute.options.dataVersion;
        var isLegacyVersion = this.checkHistoricalVersion(dataVersion);
        if (dataset === "PCM_NA" && isLegacyVersion === true) {
          dataset = dataVersion;
        }
      }
      return dataset;
    }
  }
 
})();



// WEBPACK FOOTER //
// ./app/route/route.service.js